import { Error } from '../Error'
import { Width } from '../Width'
import { Controller } from 'react-hook-form'

import { Label } from '@/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'

import type { Control, FieldErrorsImpl } from 'react-hook-form'

type RadioOption = {
  label: string
  value: string
}

export const Radio: React.FC<{
  name: string
  label: string
  options: RadioOption[]
  required?: boolean
  defaultValue?: string
  width?: number
  control: Control
  errors: Partial<FieldErrorsImpl>
}> = ({ name, control, errors, label, options, required, defaultValue }) => {
  return (
    <Width>
      <fieldset className="m-0 min-w-0 border-0 p-0">
        <legend className="mb-2 block w-full font-body text-sm leading-none font-semibold text-card-foreground">
          {label}
          {required && (
            <span className="required">
              * <span className="sr-only">(required)</span>
            </span>
          )}
        </legend>
        <Controller
          control={control}
          defaultValue={defaultValue}
          name={name}
          render={({ field: { onChange, value } }) => (
            <RadioGroup onValueChange={onChange} value={value} id={name}>
              {options?.map(({ label: optionLabel, value: optionValue }) => (
                <div key={optionValue} className="flex items-center gap-2">
                  <RadioGroupItem value={optionValue} id={`${name}-${optionValue}`} />
                  <Label
                    htmlFor={`${name}-${optionValue}`}
                    className="mb-0 cursor-pointer font-normal"
                  >
                    {optionLabel}
                  </Label>
                </div>
              ))}
            </RadioGroup>
          )}
          rules={{ required }}
        />
      </fieldset>
      {errors[name] && <Error name={name} />}
    </Width>
  )
}
